import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
export var NeighborhoodOutlineSVG = function NeighborhoodOutlineSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M27.52 8.6A5 5 0 0028 6.5 4.27 4.27 0 0024 2a4.27 4.27 0 00-4 4.5 5 5 0 00.48 2.1A6.41 6.41 0 0018 13.7a6.22 6.22 0 005 6.21V29a1 1 0 002 0v-9.09a6.22 6.22 0 005-6.21 6.41 6.41 0 00-2.48-5.1zM25 17.85V12a1 1 0 00-2 0v5.85a4.27 4.27 0 01-3-4.19 4.44 4.44 0 011.73-3.5 2 2 0 00.56-2.42A2.89 2.89 0 0122 6.5 2.3 2.3 0 0124 4a2.3 2.3 0 012 2.5 2.89 2.89 0 01-.29 1.24 2 2 0 00.56 2.42A4.46 4.46 0 0128 13.7a4.25 4.25 0 01-3 4.15zM5 23h11a1 1 0 001-1v-5a1 1 0 00-1-1H5a1 1 0 00-1 1v5a1 1 0 001 1zm1-5h9v3H6zM18 25H3a1 1 0 000 2h1v2a1 1 0 002 0v-2h9v2a1 1 0 002 0v-2h1a1 1 0 000-2z"
  }));
};
NeighborhoodOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(NeighborhoodOutlineSVG);